export default "__VITE_ASSET__CQ09pA_u__"